import { type Clip } from '@air/api/types';

import { getClipDisplayTitle } from '~/utils/getClipDisplayTitle';

type ClipImageAltSource = Pick<Clip, 'description' | 'title' | 'importedName'>;

export type ClipImageAltFallback = 'empty' | 'displayTitle';

/**
 * Alt text for an asset image. A trimmed description wins. Gallery cards that already show the
 * title pass `empty` so a blank description stays decorative. Surfaces with no title text pass
 * `displayTitle`.
 */
export const getClipImageAlt = (
  clip: ClipImageAltSource | null | undefined,
  fallback: ClipImageAltFallback,
): string => {
  const description = clip?.description?.trim();

  if (description) {
    return description;
  }

  if (fallback === 'displayTitle') {
    return getClipDisplayTitle(clip) || 'Untitled';
  }

  return '';
};
